import { lazy } from 'react'
import RequireAuthentication from '@/router/guards/RequireAuthentication'

const PatientProfile = lazy(
  () => import('@/modules/Profile/pages/PatientProfile'),
)

const ProfileRoutes = [
  <RequireAuthentication
    path="/perfil"
    key="/perfil"
    exact
    component={PatientProfile}
  />,
]

export default ProfileRoutes
